<template>
    <div id="app" >
       <!--v-touch:swipe="swipeHandler"-->
    
        <!--################-->
        <!--All preload function will be in preloader-->
        <!--Preloader-->
        <transition
            name="fade"
        >
            <Preloader v-if="settings.show_preloded"></Preloader>
        </transition>
    
        <!--################-->
        <Header :class="settings.header_class"></Header>
    
        <!--################-->
        <!--Products-->
        <transition
            enter-active-class="slideInDown"
            leave-active-class="slideOutUp"
        >
            <ProductSingle style="animation-duration: 0.5s" v-if="$route.query.product"></ProductSingle>
        </transition>
    
        <!--################-->

        <!--################-->
        <!--Mixologists-->
        <transition
            enter-active-class="slideInDown"
            leave-active-class="slideOutUp"
        >
            <MixologistsSingle style="animation-duration: 0.5s" v-if="$route.query.mixologist"></MixologistsSingle>
        </transition>

        <!--################-->
        <!--Social Icons to share-->
        <transition
            name="fade"
        >
            <ShareThis style="animation-duration: 0.5s" v-if="settings.shared"></ShareThis>
        </transition>
    
        
    
        <!--################-->
        <!--Filters-->
        <transition
            enter-active-class="slideInDown"
            leave-active-class="slideOutUp"
        >
            <Filters
                v-if="($route.query.page_filter !== undefined) && !settings.show_preloded"
                appear
                style="animation-duration: 0.5s"
            ></Filters>
        </transition>
    
    
        <!--################-->
        <!--Search-->
        <transition
            enter-active-class="slideInDown"
            leave-active-class="slideOutUp"
        >
            <Search
                v-show="settings.show_search"
                appear
                style="animation-duration: 0.5s"
            ></Search>
        </transition>
    
        <!--################-->
        <!--mainContainer-->
        <div id="mainContainer">
            <transition
                :enter-active-class="transitionNameIn"
                mode="in-out"
                v-if="!settings.show_preloded"
            >
                <!--:leave-active-class="transitionNameOut"-->
                <router-view style="animation-duration: 0.5s" :key="$route.params.id"/>
            </transition>
        </div>
    
        <!--################-->
        <!--Menu-->
        <Menu></Menu>
    </div>
</template>


<script>
    import {mapState} from "vuex"
    
    import Menu from "./components/Menu"
    import Header from "./components/Header"
    import Filters from "./components/Filters"
    import Search from "./components/Search"
    import Preloader from "./components/Preloader"
    import ShareThis from "./components/ShareThis"
    import ProductSingle from "./components/brands/ProductSingle"
    import MixologistsSingle from "./components/MixologistsSingle";
    //CSS
    import "./scss/bootstrap.css";
    import "./scss/main.scss";
    import "slick-carousel/slick/slick.css"
    
    export default {
        name: 'App',
        components: {Menu, Header, Filters, Search, Preloader, ProductSingle, ShareThis, MixologistsSingle},
        data() {
            return {
                transitionNameIn: '',
                transitionNameOut: '',
                routes: {},
            }
        },
        methods: {
            swipeHandler(direction) {
                let nextRoute = this.$router.currentRoute.meta.index;
                const routesCount = Object.keys(this.routes).length - 1;
                
                if (direction == "right") {
                    nextRoute = (--nextRoute < 0) ? routesCount : nextRoute;
                }

                if (direction == "left") {
                    nextRoute = (++nextRoute > routesCount) ? 0 : nextRoute;
                }
                /*if (direction == "bottom") {
                    this.settings.header_class = ""
                }
                if (direction == "top") {
                    this.settings.header_class = "hidden"
                }*/
                if (nextRoute != this.$router.currentRoute.meta.index) {
                    this.$router.push({name: this.routes[nextRoute]});
                }

            }
        },
        created() {
            let index = 0;
            this.$router.options.routes.forEach(route => {
                this.routes[index++] = route.name
            });
        },
        watch: {//Use watch to monitor changes in $router
            $route(to, from) {

                //Hidding Filters
                this.settings.show_filters = false;
                this.settings.show_search = false;
                this.settings.header_class = ""
                
                //If the to index is larger than the from index, it is judged to be in the forward state, and vice versa, in the backward state
                if ( to.meta.index > from.meta.index ) {
                    //Setting Animation Name
                    this.transitionNameIn = 'slideInRight';
                    this.transitionNameOut = 'slideOutLeft';
                } else {
                    this.transitionNameIn = 'slideInLeft';
                    this.transitionNameOut = 'slideOutRight';
                }
            }
        },
        computed: {
            ...mapState("shared", ["settings", "preloaded"])
        }
    }
</script>
